import { render, staticRenderFns } from "./btn-selector.vue?vue&type=template&id=e303c5c4"
import script from "./btn-selector.vue?vue&type=script&lang=js"
export * from "./btn-selector.vue?vue&type=script&lang=js"
import style0 from "./btn-selector.vue?vue&type=style&index=0&id=e303c5c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports